import { Flex } from 'antd';

type Legend = {
  legend: string;
  value: number;
  color?: string;
};

export const LegendText = ({
  legend,
  dot = true,
  valueStyle,
  legendStyle,
}: {
  legend: Legend;
  dot?: boolean;
  legendStyle?: React.CSSProperties;
  valueStyle?: React.CSSProperties;
}) => {
  return (
    <Flex
      key={legend?.legend}
      justify="space-between"
      gap={20}
      align="center"
      className="mt-2"
      style={{ width: '100%' }}
    >
      <Flex justify="center" align="center" gap={8}>
        <Flex align="center" gap={8} className="legend">
          {dot && <div className="dot" style={{ background: legend?.color }} />}
          <span style={legendStyle}>{legend?.legend}</span>
        </Flex>
      </Flex>
      <span
        className="season-overview__widget-text--title text-strong"
        style={valueStyle}
      >
        {legend?.value}
      </span>
    </Flex>
  );
};
